import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image';
import React from 'react';
import { fallbackImage } from '../utils';
import styled from '@emotion/styled';
import { devices } from '../styles/breakpoints';

/* In order to be able to use this base Component, your query needs to provide 2 images.. default one and mobile version */

/* For aspect ratio of 3.10303, padding bottom was set to 32.25% which was used in tablet mode. For mobile, in order to get 1.77778 of aspect ratio, padding bottom was set to 56.25%. Apart from that, on desktop there is just fixed height.   */

const OfflineBackgroundImage = styled.div`
  position: relative;
  height: auto;
  overflow: hidden;
  background-image: url(${fallbackImage});
  background-size: cover;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  padding-bottom: 56.25%;

  @media ${devices.mobileMin} {
    padding-bottom: 32.25%;
  }

  @media ${devices.tabletMin} {
    height: 387px;
    padding-bottom: 0;
  }
`;

const ResponsiveImage = ({ defaultImage, mobileImage, altTag }) => {
  const images = withArtDirection(getImage(defaultImage), [
    {
      media: '(max-width: 600px)',
      image: getImage(mobileImage),
    },
  ]);
  const [isOnline, setIsOnline] = React.useState(true);

  React.useEffect(() => {
    if (!window.navigator.onLine) {
      setIsOnline(false);
    }
  }, []);

  return (
    <>
      {isOnline ? (
        <GatsbyImage className="art-directed" image={images} alt={altTag} />
      ) : (
        <OfflineBackgroundImage />
      )}
    </>
  );
};

export default ResponsiveImage;
